import { Card, CardContent } from '@/components/ui/layout/card';
import { cn } from '@/lib/utils';
import { MetricInfoButton } from '@/components/MetricInfoButton';

interface CoachKpiCardProps {
  label: string;
  value: string | number;
  subtext: string;
  variant?: 'default' | 'success' | 'warning' | 'danger';
  /** Key into metricDefinitions for the info popover */
  metricKey?: string;
}

const variantToTextClass: Record<string, string> = {
  default: '',
  success: 'text-green-600 dark:text-green-400',
  warning: 'text-amber-600 dark:text-amber-400',
  danger: 'text-red-600 dark:text-red-400',
};

/**
 * KPI Card for Coach Dashboard
 * Displays a single metric with label, value, and subtext
 */
export function CoachKpiCard({ label, value, subtext, variant = 'default', metricKey }: CoachKpiCardProps) {
  const valueColorClass = variantToTextClass[variant];

  return (
    <Card>
      <CardContent className="pt-6">
        <span className="text-xs uppercase tracking-wider text-muted-foreground flex items-center gap-1 mb-2">
          {label}
          {metricKey && <MetricInfoButton metricKey={metricKey} />}
        </span>
        <p className={cn('text-3xl font-semibold', valueColorClass)}>{value}</p>
        <p className="text-xs text-muted-foreground mt-2">{subtext}</p>
      </CardContent>
    </Card>
  );
}
